/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_CloudiconInputs */

const en_enum_custom_page_icon_cloudicon = /** @type {(inputs: Enum_Custom_Page_Icon_CloudiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud`)
};

const de_enum_custom_page_icon_cloudicon = /** @type {(inputs: Enum_Custom_Page_Icon_CloudiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wolke`)
};

/**
* | output |
* | --- |
* | "Cloud" |
*
* @param {Enum_Custom_Page_Icon_CloudiconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_cloudicon = /** @type {((inputs?: Enum_Custom_Page_Icon_CloudiconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_CloudiconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_cloudicon(inputs)
	return de_enum_custom_page_icon_cloudicon(inputs)
});